import { render, staticRenderFns } from "./BigIdInputModal.vue?vue&type=template&id=20971bfc&scoped=true&"
import script from "./BigIdInputModal.vue?vue&type=script&lang=ts&"
export * from "./BigIdInputModal.vue?vue&type=script&lang=ts&"
import style0 from "./BigIdInputModal.vue?vue&type=style&index=0&id=20971bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20971bfc",
  null
  
)

export default component.exports